import { useState } from 'react';

/**
 * CTA 按下态 + 点击分发，模板间共享。返回一个 onClick,挂到 <button> 上。
 *
 * 排查结论(真机 console 验证):x-safari scheme 在这个 TikTok webview 里,只要
 * location.href 被设置就会弹"在 Safari 打开?",**不依赖 user gesture**。所以普通
 * React onClick 完全够用 —— 关键只是"点击要真的触发 onAccept"。
 */
export function useCtaPress(onAccept: (kind: 'click' | 'touch') => void) {
  const [pressed, setPressed] = useState(false);
  return {
    pressed,
    onClick: () => {
      onAccept('touch');
      setPressed(true);
      setTimeout(() => setPressed(false), 600);
    },
  };
}

/** 把 hex 颜色每个通道压暗 amount，用于按钮按下态。模板间共享，避免各自手抄。 */
export function darken(hex: string, amount = 30): string {
  const n = Number.parseInt(hex.replace('#', ''), 16);
  const r = Math.max(0, (n >> 16) - amount);
  const g = Math.max(0, ((n >> 8) & 0xff) - amount);
  const b = Math.max(0, (n & 0xff) - amount);
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
}
